import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { agregarToken, limpiarSesion } from "../../features/ui/uiSlice";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store";
import { Spinner } from "../Spinner";
import { useLogoutMutation } from "../../services/docs";

export const BarTopComponent = () => {
  const { usuario } = useSelector((state: RootState) => state.ui);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [logoutApi] = useLogoutMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const menuRef = useRef(null);
  const handleProfileClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const cerrarSesion = async () => {
    try {
      await logoutApi({}).unwrap();
    } catch (error) {
      console.error("Error cerrando sesión en el servidor", error);
    } finally {
      dispatch(limpiarSesion());
      navigate("/auth/login", { replace: true });
    }
  };

  const handleEditProfile = () => {
    setIsMenuOpen(false);
    navigate("/home/editar-perfil");
  };
  return (
    <div className="max-w-full">
      <div className="flex items-center justify-between bg-white  px-4 py-1 shadow-sm">
        <div className="font-medium text-gray-600"></div>

        {usuario && (
          <div className="relative" ref={menuRef}>
            <button
              onClick={handleProfileClick}
              className="flex items-center space-x-4 focus:outline-none"
            >
              <div className="text-right">
                <p className="flex justify-end text-right text-sm font-semibold text-gray-800">
                  <span>
                    Hola {usuario.nombreUsuario} {usuario.appUsuario}
                  </span>
                </p>
                <p className="flex text-right text-sm text-gray-500">
                  <span className="">{usuario.username}</span>
                </p>
              </div>
              <div className="flex h-10 w-10 items-center justify-center rounded-full">
                <img src={usuario.fc_avatar} />
              </div>
              <p className="mx-1 rounded-xl bg-primary px-1 py-0.5 text-white">
                {usuario.fc_pefil_nombre}
              </p>
            </button>

            {isMenuOpen && (
              <div className="absolute right-0 !z-[999] mt-2 w-48 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5">
                <button
                  onClick={handleEditProfile}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                >
                  Editar perfil
                </button>
                <button
                  onClick={cerrarSesion}
                  className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-100"
                >
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
